import { ActionIcon, Menu } from '@mantine/core';
import { OptionType } from '@morph-mapper/types';
import {
  PiBracketsCurlyBold,
  PiCode,
  PiCodepenLogo,
  PiTextTBold,
  PiToggleLeft,
} from 'react-icons/pi';
import { IoMdRadioButtonOff, IoMdRadioButtonOn } from 'react-icons/io';
import { match } from 'ts-pattern';
import { t } from 'i18next';

export type OptionTypeMenuProps = {
  value: OptionType;
  onChange: (type: OptionType) => void;
  allowedTypes?: OptionType[];
};

const allTypeOptions = [
  { value: OptionType.UserDefined, label: 'graphEditor.optionType.literal' },
  { value: OptionType.Reference, label: 'graphEditor.optionType.reference' },
  { value: OptionType.Graph, label: 'graphEditor.optionType.graph' },
  { value: OptionType.Code, label: 'graphEditor.optionType.code' },
  { value: OptionType.Boolean, label: 'graphEditor.optionType.boolean' },
];

export const OptionTypeMenu = ({ value, onChange, allowedTypes }: OptionTypeMenuProps) => {
  const typeOptions = allowedTypes
    ? allTypeOptions.filter((o) => allowedTypes.includes(o.value))
    : allTypeOptions.slice(0, 3);

  const TypeIcon = match(value)
    .with(OptionType.Reference, () => PiBracketsCurlyBold)
    .with(OptionType.Graph, () => PiCodepenLogo)
    .with(OptionType.UserDefined, () => PiTextTBold)
    .with(OptionType.Code, () => PiCode)
    .with(OptionType.Boolean, () => PiToggleLeft)
    .exhaustive();

  return (
    <Menu shadow="md" width={160} position="bottom-end">
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          size="sm"
          radius="sm"
          aria-label={t('graphEditor.optionType.label')}
        >
          <TypeIcon size={16} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{t('graphEditor.optionType.title')}</Menu.Label>
        {typeOptions.map((item) => (
          <Menu.Item
            key={item.value}
            icon={
              value === item.value ? (
                <IoMdRadioButtonOn />
              ) : (
                <IoMdRadioButtonOff />
              )
            }
            onClick={() => onChange(item.value)}
          >
            {t(item.label)}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
